export default __webpack_public_path__ + "static/henna-homepage-banner-mobile-efd41b9c05fb7579e60686ea48351118.webp";